<template>
    <b-modal
        id="treatementActivity"
        ref="treatementActivity"
        :lazy="true"
        :title="title"
        no-close-on-backdrop
        title-tag="h2"
        @shown="shown"
        @hidden="hidden"
    >
        <b-form>
            <b-alert show variant="warning" v-if="is_locked">
                {{ locked.message }}
            </b-alert>
            <b-form-group
                v-if="!isTemplate"
                label="Patient:"
                label-cols="3"
                label-for="patient_id"
            >
                <v-select
                    v-if="action === 'new' && !disablePatientField"
                    id="patient_id"
                    ref="vselect"
                    v-model="data.patient"
                    v-validate="'required'"
                    :disabled="is_locked"
                    :options="pOptions"
                    :class="{
                        'border-danger': errors.has('patient_id'),
                        rounded: true
                    }"
                    placeholder="Patient Name (required)"
                    name="patient_id"
                    label="name"
                    @input="patientChange"
                />
                <p v-else class="plain-text">
                    {{ data.patient ? data.patient.name : null }}
                </p>
            </b-form-group>
            <b-form-group
                :label-for="`treatment_activity_type_id`"
                :label-cols="3"
                label="Type:"
            >
                <b-form-select
                    v-model="data.treatment_activity_type_id"
                    v-validate="'required'"
                    :disabled="is_locked"
                    :options="activityType"
                    :class="{
                        'border-danger': errors.has(
                            'treatment_activity_type_id'
                        ),
                        rounded: true
                    }"
                    name="treatment_activity_type_id"
                ></b-form-select>
            </b-form-group>
            <b-form-group
                v-if="data.treatment_activity_type_id == 1"
                :label-for="`item_id`"
                :label-cols="3"
                label="Medication:"
            >
                <vet-select
                    v-if="!isTemplate"
                    id="item"
                    v-model="data.item"
                    :disabled="is_locked"
                    v-validate="'required'"
                    :class="{
                        'border-danger': errors.has('item'),
                        rounded: true
                    }"
                    :multiple="isItemMultiple"
                    :module="vetItemModule"
                    :selectProps="vetItemProps"
                    placeholder="Select Medication (required)"
                    name="item"
                />
                <b-form-select
                    v-else
                    id="item"
                    ref="item"
                    v-model="data.item"
                    :disabled="is_locked"
                    v-validate="'required'"
                    :options="invoiceBundleItems"
                    :class="{
                        'border-danger': errors.has('item'),
                        rounded: true
                    }"
                    name="item"
                ></b-form-select>
            </b-form-group>
            <b-form-group
                v-if="data.treatment_activity_type_id == 1 && itemType != 7"
                :label-for="'quantity'"
                :label-cols="3"
                label="Quantity:"
            >
                <div class="d-flex align-items-center">
                    <b-form-input
                        id="quantity"
                        :disabled="is_locked"
                        v-model="data.quantity"
                        name="quantity"
                        class="flex-grow-1"
                        type="number"
                        @blur="quantityBlur"
                    ></b-form-input>
                    <span class="ml-2">
                        {{
                            data.item && data.item.uom
                                ? data.item.uom
                                : "Unit(s)"
                        }}
                    </span>
                    <dosage
                        v-if="!isTemplate"
                        :data="{ form_data: form_data }"
                        :weight-data="{
                            weight: weight.value,
                            uom: weight.uom_id
                        }"
                        :item-id="itemId"
                        target="quantity"
                        parent-id="treatementActivity"
                        class="btn-sm ml-2"
                    />
                </div>
            </b-form-group>

            <b-form-group
                v-if="data.treatment_activity_type_id == 1 && itemType != 7"
                :label-for="`route`"
                :label-cols="3"
                label="Route:"
            >
                <b-form-select
                    v-model="data.route"
                    :disabled="is_locked"
                    :options="routesFilter"
                    name="route"
                ></b-form-select>
            </b-form-group>
            <b-form-group
                v-if="data.treatment_activity_type_id == 1 && itemType != 7"
                :label-for="`location`"
                :label-cols="3"
                label="Location:"
            >
                <b-form-select
                    :disabled="is_locked"
                    v-model="data.location"
                    :options="locationsFilter"
                    name="location"
                ></b-form-select>
            </b-form-group>
            <b-form-group
                v-if="data.treatment_activity_type_id == 2"
                :label-for="`vital`"
                :label-cols="3"
                label="Vitals:"
            >
                <keep-alive>
                    <treeselect
                        name="vital"
                        v-validate="'required'"
                        :options="vitalsWithSelectAll"
                        v-model="data.vital"
                        placeholder="Vital (required)"
                        :multiple="true"
                        :flattenSearchResults="true"
                        :disableFuzzyMatching="true"
                        :clearOnSelect="true"
                        :closeOnSelect="false"
                        :value-consists-of="'LEAF_PRIORITY'"
                        :default-expand-level="1"
                        :noResultsText="'Sorry, no matching options'"
                        class="treeselect-select-all"
                        valueFormat="object"
                        :class="{
                            'treeselect-invalid': formError.includes('vital')
                        }"
                        @input="updateSelectedVital"
                    >
                        <span
                            slot="option-label"
                            slot-scope="{ node }"
                            class="font-weight-normal"
                        >
                            {{ node.label }}
                        </span>
                    </treeselect>
                </keep-alive>
            </b-form-group>
            <b-form-group
                v-if="data.treatment_activity_type_id == 3"
                label-cols="3"
                label-for="label"
            >
                <v-select
                    v-model="data.label"
                    v-validate="'required'"
                    :options="labelOptions"
                    :disabled="is_locked"
                    :label="'text'"
                    :class="{ 'border-danger': errors.has('label') }"
                    name="label"
                    placeholder="Label (required)"
                ></v-select>
            </b-form-group>
            <b-form-group
                v-if="!isTemplate"
                :label="
                    data.treatment_activity_type_id == 3 &&
                    data.label.value == isMiscellaneous
                        ? 'Details'
                        : 'Notes:'
                "
                label-cols="3"
                label-for="notes"
            >
                <textarea
                    id="notes"
                    v-validate="
                        data.treatment_activity_type_id == 3 &&
                        data.label.value == isMiscellaneous
                            ? 'required'
                            : ''
                    "
                    v-model="note"
                    :disabled="is_locked"
                    class="form-control"
                    :placeholder="
                        data.treatment_activity_type_id == 3 &&
                        data.label.value == isMiscellaneous
                            ? 'Details (required)'
                            : 'Note (optional)'
                    "
                    :class="
                        data.treatment_activity_type_id == 3 &&
                        data.label.value == isMiscellaneous
                            ? { 'border-danger': errors.has('notes') }
                            : {}
                    "
                    name="notes"
                    rows="3"
                ></textarea>
            </b-form-group>
            <b-form-group
                v-else-if="isTemplate && data.treatment_activity_type_id == 3"
                label="Description:"
                label-cols="3"
                label-for="description"
                >{{ data.other_task }}
                <textarea
                    id="description"
                    v-validate="
                        data.treatment_activity_type_id == 3 &&
                        data.label.value == isMiscellaneous
                            ? 'required'
                            : ''
                    "
                    v-model="note"
                    :disabled="is_locked"
                    class="form-control"
                    :placeholder="
                        data.treatment_activity_type_id == 3 &&
                        data.label.value == isMiscellaneous
                            ? 'Description (required)'
                            : 'Description (optional)'
                    "
                    :class="
                        data.treatment_activity_type_id == 3 &&
                        data.label.value == isMiscellaneous
                            ? { 'border-danger': errors.has('description') }
                            : {}
                    "
                    name="description"
                    rows="3"
                ></textarea>
            </b-form-group>
            <b-form-group :label-for="'due_type'" :label-cols="3" label="Due:">
                <div class="d-flex align-items-center">
                    <!-- Dropdown -->
                    <b-form-select
                        id="due_type"
                        v-model="data.due_type"
                        :options="filteredDues"
                        :disabled="is_locked"
                        name="due_type"
                        class="form-control"
                        :style="
                            data.due_type === 2
                                ? { flex: '1 1 60%' }
                                : { width: '12.2rem' }
                        "
                    ></b-form-select>

                    <!-- Datetime Picker -->
                    <vet-datetime
                        v-if="data.due_type === 2"
                        v-model="data.due"
                        :disabled="is_locked"
                        v-validate="'required'"
                        :class="{
                            'border-danger': errors.has('due-specific-time')
                        }"
                        id="due-specific-time"
                        name="due-specific-time"
                        class="ml-2"
                        style="flex: auto;"
                        :placeholder="{
                            date: 'Date (required)',
                            time: 'Time (required)'
                        }"
                        container="#treatementActivity"
                        rules="required"
                        format="DateTime"
                    ></vet-datetime>
                </div>
            </b-form-group>
            <b-form-group v-if="data.due_type === 1" :label-cols="3">
                <!-- Numeric Input -->
                <div class="d-flex align-items-center" style="flex: 30%;">
                    <b-form-input
                        id="due-after-start-treatment-day"
                        v-model.number="dueInDays"
                        v-validate="'numeric'"
                        type="number"
                        :disabled="is_locked"
                        name="due-after-start-treatment-day"
                        class="form-control"
                    ></b-form-input>
                    <span class="ml-2 mr-2">day(s)</span>
                    <b-form-input
                        id="due-after-start-treatment-hour"
                        v-model.number="dueInHours"
                        v-validate="'numeric'"
                        type="number"
                        :disabled="is_locked"
                        name="due-after-start-treatment-hour"
                        class="form-control"
                    ></b-form-input>
                    <span class="ml-2 mr-2">hour(s)</span>
                    <b-form-input
                        id="due-after-start-treatment-minutes"
                        v-model.number="dueInMinutes"
                        v-validate="'required|numeric'"
                        type="number"
                        :disabled="is_locked"
                        :class="{
                            'border-danger': errors.has(
                                'due-after-start-treatment-minutes'
                            )
                        }"
                        name="due-after-start-treatment-minutes"
                        class="form-control"
                    ></b-form-input>
                    <span class="ml-2">minute(s)</span>
                </div>
            </b-form-group>
            <b-form-group
                label="Apply To:"
                label-cols="3"
                label-for="apply_to"
                v-if="isRecurring(data) && !isTemplate"
            >
                <b-form-select
                    v-model="data.apply_to"
                    :disabled="is_locked"
                    :options="[
                        { value: 0, text: 'This activity only' },
                        {
                            value: 1,
                            text:
                                'This and all future occurrences of this activity'
                        }
                    ]"
                    :class="{
                        'border-danger': errors.has(
                            'treatment_activity_type_id'
                        ),
                        rounded: true
                    }"
                    name="apply_to"
                ></b-form-select>
            </b-form-group>
            <b-form-group
                v-if="
                    showRepeatOnEdit ||
                    action === 'new' ||
                    action === 'duplicate'
                "
                :label-for="'repeat'"
                :label-cols="3"
                label="Occurrence:"
            >
                <div class="d-flex align-items-center">
                    <b-form-select
                        id="repeat_type"
                        v-model="data.repeat_type"
                        :options="repeatOptions"
                        :disabled="is_locked"
                        name="repeat_type"
                        class="form-control"
                        style="width: 12.2rem;"
                    ></b-form-select>
                    <div
                        v-if="data.repeat_type === 2"
                        style="width: 8rem;"
                        class="ml-2"
                    >
                        <timepicker
                            v-model="data.due"
                            :disabled="is_locked"
                            v-validate="'required'"
                            :class="{ 'border-danger': errors.has('due') }"
                            name="due"
                            class="form-control"
                            style="width: 8.8rem;"
                        />
                    </div>
                </div>
            </b-form-group>
            <b-form-group
                v-if="data.repeat_type != 0"
                :label-for="'repeat'"
                :label-cols="3"
            >
                <div class="d-flex align-items-center">
                    <div
                        v-if="data.repeat_type === 1"
                        class="d-flex align-items-center"
                    >
                        <b-form-input
                            id="occurrence"
                            v-model="data.occurence"
                            v-validate="'required|numeric'"
                            :class="{
                                'border-danger': errors.has('occurrence')
                            }"
                            :disabled="is_locked"
                            type="number"
                            min="1"
                            max="99"
                            step="1"
                            name="occurrence"
                            class="form-control"
                            style="width: 3.3rem;"
                        ></b-form-input>
                        <span class="mx-2">times every</span>
                        <b-form-input
                            id="specific_interval"
                            v-model.number="data.specific_interval"
                            :disabled="is_locked"
                            v-validate="'required|numeric'"
                            type="number"
                            :class="{
                                'border-danger': errors.has('specific_interval')
                            }"
                            name="specific_interval"
                            class="form-control"
                            style="width: 3.3rem;"
                        ></b-form-input>
                        <b-form-select
                            id="repeat_interval"
                            v-model="data.repeat_interval"
                            :options="repeatIntervalOptions"
                            :disabled="is_locked"
                            name="repeat_interval"
                            class="form-control custom-select ml-2"
                            style="width: 8.9rem;"
                        ></b-form-select>
                    </div>
                </div>
            </b-form-group>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                class="float-left"
                variant="secondary"
                @click="$refs.treatementActivity.hide('cancel')"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button
                    v-else-if="action === 'edit' || action === 'duplicate'"
                    :disabled="is_locked"
                    variant="primary"
                    @click="isTemplate ? saveTemplate(false) : save(false)"
                    >Save</b-button
                >
                <b-button
                    v-else-if="action === 'reactivate'"
                    :disabled="is_locked"
                    variant="primary"
                    @click="save(false)"
                    >Reactivate</b-button
                >
                <b-button-group v-else>
                    <b-dropdown
                        v-if="!continues"
                        :disabled="is_locked"
                        left
                        split
                        text="Save + Done"
                        variant="primary"
                        @click="isTemplate ? saveTemplate(false) : save(false)"
                    >
                        <b-dropdown-item
                            @click="
                                isTemplate ? saveTemplate(true) : save(true)
                            "
                            >Save + Add New</b-dropdown-item
                        >
                    </b-dropdown>
                    <b-dropdown
                        v-else
                        :disabled="is_locked"
                        left
                        split
                        text="Save + Add New"
                        variant="primary"
                        @click="isTemplate ? saveTemplate(true) : save(true)"
                    >
                        <b-dropdown-item
                            @click="
                                isTemplate ? saveTemplate(false) : save(false)
                            "
                            >Save + Done</b-dropdown-item
                        >
                    </b-dropdown>
                </b-button-group>
            </div>
        </div>
    </b-modal>
</template>
<style></style>
<script>
import Treeselect from "@riophae/vue-treeselect";
import vetSelect from "@/module/commons/vet-select.vue";
import vSelect from "vue-select";
import Timepicker from "@/module/commons/time-picker.vue";
import ScheduleHelper from "../helper";
import {
    difference,
    merge,
    times,
    get,
    some,
    filter,
    map,
    chain,
    find,
    differenceBy
} from "lodash";
import { DateTime } from "luxon";
import Dosage from "@/module/commons/dosage.vue";
import TEMPLATES from "@/constants/templates";
import TEMPLATE_SERVICES from "@/services/templates";
import vetDatetime from "@/module/commons/date-time-picker.vue";
const DUPLICATE_ACTIVITY = "duplicate";

export default {
    name: "TreatementActivity",
    components: {
        vetSelect,
        vSelect,
        Treeselect,
        Timepicker,
        Dosage,
        vetDatetime
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            isItemMultiple: false,
            itemType: "",
            tempItem: [],
            search_text: "",
            continues: false,
            loading: false,
            recreateActivity: false,
            timeChange: false,
            action: "new",
            currencySymbol: "$",
            note: "",
            vetItemModule: "item",
            vetItemProps: {
                id: "",
                item_type: "",
                module: "patient",
                status: "",
                start: "",
                source: ""
            },
            data: {
                id: null,
                patient: null,
                oriItem: null,
                item: [],
                treatment_activity_type_id: null,
                uom: null,
                staffs: null,
                due_type: 2,
                due: 15,
                repeat: 0,
                note: "",
                quantity: 0,
                route: 0,
                location: 0,
                repeat_type: 0,
                label: {
                    value: 1,
                    text: "Miscellaneous"
                },
                specific_interval: 15,
                specific_time: 15,
                repeat_interval: "minutes",
                occurrence_id: null,
                occurence: 1,
                apply_to: 0,
                vital: []
            },
            dues: [
                {
                    value: 1,
                    text: "After start of treatment"
                },
                {
                    value: 2,
                    text: "At specific time"
                }
            ],
            repeatOptions: [
                { value: 0, text: "Not recurring" },
                { value: 1, text: "Recurring" }
            ],
            repeatIntervalOptions: [
                { value: "minutes", text: "Minute(s)" },
                { value: "hours", text: "Hour(s)" },
                { value: "days", text: "Day(s)" },
                { value: "weeks", text: "Week(s)" },
                { value: "months", text: "Month(s)" }
            ],
            uom: [
                {
                    value: 1,
                    text: "uom"
                },
                {
                    value: 2,
                    text: "uom"
                }
            ],
            type: [
                {
                    value: null,
                    text: "Select type of activity (required)"
                },
                {
                    value: 1,
                    text: "Medical"
                },
                {
                    value: 2,
                    text: "Vitals"
                },
                {
                    value: 3,
                    text: "Other"
                }
            ],
            staffList: [],
            roleList: [],
            routes: [],
            locations: [],
            bundles: [],
            pOptions: [],
            form_data: {
                dosage: []
            },
            skipWatch: false,
            previousDue: "",
            invoiceBundleItems: [],
            formError: [],
            disablePatientField: false,
            treatmentBoardPatient: null,
            getDataFromFetchPatient: false,
            dueInDays: 0,
            dueInHours: 0,
            dueInMinutes: 0,
            isReset: false
        };
    },
    props: {
        isTemplate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        title() {
            // action === 'new' ? 'New Activity' : 'Edit Activity'
            if (this.action === "new") {
                return "New Activity";
            } else if (this.action === "edit") {
                return "Edit Activity";
            } else {
                return "Duplicate Activity";
            }
        },
        itemId() {
            let item = this.data.item;
            if (!Array.isArray(item)) {
                item = [item];
            }
            return item.length > 0 ? item[0].id : "";
        },
        // TODO: will be moved to helper component soon
        staff_options_exclude() {
            let combine = this.staffList.concat(
                [{ type: "divider" }],
                this.roleList
            );
            return difference(combine, this.data.staffs);
        },
        vitalOptions() {
            return filter(
                get(this.$store.state.reference, "master-vital", []),
                value => some(value.master_uom)
            ).map(value => ({
                id: value.id,
                label: value.vital,
                master_uom_id: value.master_uom[0].id,
                isDisabled: false
            }));
        },
        vitalsWithSelectAll() {
            // Append the "Select All" option on children
            return [
                {
                    id: "all",
                    label: "Select All",
                    isDisabled: false,
                    isDefaultExpanded: true,
                    children: this.vitalOptions
                }
            ];
        },
        routesFilter() {
            return [
                { value: "0", text: "None" },
                ...this.routes.map(route => ({
                    value: route.id,
                    text: route.value
                }))
            ];
        },
        locationsFilter() {
            return [
                { value: "0", text: "None" },
                ...this.locations.map(location => ({
                    value: location.id,
                    text: location.value
                }))
            ];
        },
        weight() {
            const defaultValue = { value: null, uom_id: null };
            if (!this.data.patient) {
                return defaultValue;
            }

            const vitals = get(
                this.$store.state.patients,
                this.data.patient.id + ".vitals",
                null
            );
            let weight = _.find(vitals, { type: 4 });
            return vitals && weight ? weight : defaultValue;
        },
        labelOptions() {
            return this.$store.state.reference["treatment-task-label"];
        },
        isMiscellaneous() {
            let miscId = this.labelOptions.find(label => label.value == 1);
            return miscId?.value;
        },
        locked() {
            return this.data.id && this.action === "edit"
                ? this.$store.getters.locked(this.data.id)
                : null;
        },
        is_locked() {
            return some(this.locked);
        },
        templateId() {
            return this.$store.state.settingsTemplate.templateId;
        },
        showRepeatOnEdit() {
            return this.isTemplate
                ? this.action === "edit"
                : this.action === "edit" && this.data.apply_to === 1;
        },
        activityType: {
            get() {
                if (this.isTemplate) {
                    return this.type.slice(1);
                }
                return this.type;
            },
            set(list) {
                this.type = list;
            }
        },
        uoms() {
            return this.$store.state.references.uoms;
        },
        filteredDues() {
            // Return only "At specific time" option when duplicating activity
            if (this.action === DUPLICATE_ACTIVITY) {
                return filter(this.dues, due => due.value === 2);
            }
            // Return all options for other cases
            return this.dues;
        },
        totalDue() {
            let daysInMinutes = this.dueInDays * 24 * 60;
            let hoursInMinutes = this.dueInHours * 60;
            let minutes = this.dueInMinutes;
            return daysInMinutes + hoursInMinutes + minutes;
        }
    },
    mounted() {},
    beforeRouteEnter(to, from, next) {
        next(self => {
            if (to.params.patient) {
                self.disablePatientField = true;
                self.treatmentBoardPatient = to.params.patient;
            }
            self.$refs["treatementActivity"].show();
        });
    },
    watch: {
        "data.due"(due) {
            if (this.data.due_type == 1) {
                let dueInDays = Math.floor(due / (24 * 60));
                let dueInHours = Math.floor((due % (24 * 60)) / 60);
                let dueInMinutes = (due % (24 * 60)) % 60;

                this.dueInDays = this.isReset ? 0 : dueInDays;
                this.dueInHours = this.isReset ? 0 : dueInHours;
                this.dueInMinutes = this.isReset ? 15 : dueInMinutes;
            }
            this.isReset = false;
        },
        "data.item"(value, oldData) {
            if (this.isTemplate) {
                const selectedItem = value.item;
                if (selectedItem) {
                    let quantity = 0;
                    if (
                        (this.action == "edit" ||
                            this.action == DUPLICATE_ACTIVITY) &&
                        this.data.oriItem?.item_id == value.item_id
                    ) {
                        quantity = value.quantity;
                    }
                    this.data.quantity = quantity;
                    this.data.route = selectedItem.route;
                    this.data.location = selectedItem.location;
                }
            } else {
                if (!Array.isArray(value)) {
                    value = [value];
                    if (value[0].item_type != 7) {
                        this.data.item = value;
                    }
                }
                if (this.isItemMultiple) {
                    if (value.length == 0) {
                        this.data.item = this.tempItem;
                    }
                }
                let valid = true;
                if (
                    this.action == "edit" ||
                    this.action == DUPLICATE_ACTIVITY
                ) {
                    valid = false;
                }
                if (oldData.length > 0 && !_.isEqual(value, oldData)) {
                    valid = true;
                }

                if (value.length > 0 && valid) {
                    if (value[0].route) {
                        this.data.route = value[0].route;
                    }
                    if (value[0].location) {
                        this.data.location = value[0].location;
                    }
                    if (value[0].dose) {
                        this.data.quantity = value[0].dose;
                    }
                    if (value[0].dosage) {
                        this.form_data.dosage = value[0].dosage;
                    }
                    if (value[0].item_type == 7) {
                        this.itemType = 7;
                        this.isItemMultiple = true;
                        this.vetItemModule = "item-lab";
                        this.vetItemProps.source = value[0].source;
                        this.tempItem = [this.data.item];
                    } else {
                        this.isItemMultiple = false;
                        this.isHideQuantity = false;
                    }
                } else {
                    this.vetItemModule = "item";
                }
            }
        },
        "data.due_type": {
            handler(value) {
                if (!this.timeChange) {
                    if (value === 2) {
                        this.data.due = DateTime.local().setZone(
                            this._timeZone
                        );
                    } else {
                        this.data.due = 15;
                    }
                }
            },
            immediate: true
        },
        "data.repeat_type"(value) {
            if (value === 2) {
                this.data.due = DateTime.local().setZone(this._timeZone);
            }
        },
        "data.apply_to"(value) {
            this.data.repeat_type = value;
            if (value) {
                this.recreateActivity = true;
            } else {
                this.recreateActivity = false;
            }
        }
    },
    methods: {
        onSearch(search) {
            this.remote_options = [];
            this.search_text = search;
            if (search.length >= 2) {
                this.loading = true;
                this.filterOptions(search);
            }
        },
        setSearchText(event) {
            this.txt = this.search_text;
            this.$emit("search:blur", event);
        },
        open(params) {
            let self = this;
            self.action = params.action;
            self.getDataFromFetchPatient = params.getDataFromFetchPatient;

            // VET-4071 : Since the activity modal for due is default to "At Specific Time"
            // current time will be set on open.
            if (self.isTemplate) {
                self.data.due_type = 1;
            } else {
                self.data.due = DateTime.local().setZone(this._timeZone);
            }
            if (params.patient) {
                self.disablePatientField = true;
                self.treatmentBoardPatient = params.patient;
            }
            self.$refs["treatementActivity"].show();
            if (self.isTemplate) {
                self.templateActivityEdit(params);
            } else {
                self.scheduleActivityEdit(params);
            }
        },
        scheduleActivityEdit(params) {
            let self = this;
            if (
                self.action === "edit" ||
                self.action === "reactivate" ||
                self.action === DUPLICATE_ACTIVITY
            ) {
                self.action === "edit"
                    ? self.repeatOptions.push({
                          value: 2,
                          text: "At specific time"
                      })
                    : "";
                self.data = merge(self.data, params);
                self.previousDue = self.data.due;
                self.previousRepeat = params.repeat
                    ? JSON.parse(params.repeat)
                    : null;
                self.getActivity(params.id).then(action => {
                    // Modify the properties in the activity object as default value
                    if (self.action == DUPLICATE_ACTIVITY) {
                        action.occurence = 1;
                        action.specific_interval = 15;
                        action.repeat_interval = "minutes";
                        action.due_type = 2;
                        action.due = DateTime.local()
                            .setZone(this._timeZone)
                            .toSeconds();
                    }
                    self.data = merge(self.data, action);
                    self.note = self.data.note;
                    switch (action.treatment_activity_type_id) {
                        case 1:
                            if (action.medications.length > 0) {
                                let items = [];
                                $.each(action.medications, function (
                                    key,
                                    value
                                ) {
                                    self.getInventoryItem(value.item_id).then(
                                        item => {
                                            ``;
                                            let array = {
                                                ...item,
                                                label:
                                                    item.name +
                                                    " (" +
                                                    self._setting
                                                        .currency_symbol +
                                                    item.price +
                                                    "/" +
                                                    item.uom.label +
                                                    ")",
                                                raw_id: item.id,
                                                uom: item.uom.label,
                                                item_type: item.itemType.id,
                                                treatment_medication_id:
                                                    value.id
                                            };
                                            if (item.itemType.id == 7) {
                                                self.isItemMultiple = true;
                                            }
                                            self.treatment_medication_id =
                                                action.medications[0].id;
                                            self.data.quantity =
                                                action.medications[0].quantity;
                                            self.data.route =
                                                action.medications[0].route_id;
                                            self.data.location =
                                                action.medications[0].location_id;

                                            items.push(array);

                                            if (
                                                items.length ==
                                                action.medications.length
                                            ) {
                                                self.data.item = items;
                                                self.skipWatch = true;
                                            }
                                        }
                                    );
                                });
                            }
                            break;
                        case 2:
                            self.data.vital = self.data.treatment_vitals.map(
                                vital => ({
                                    master_uom_id: vital.master_uom.id,
                                    label: vital.master_vital.vital,
                                    id: vital.master_vital.id
                                })
                            );
                            break;
                        case 3:
                            self.data.label = _.find(this.labelOptions, {
                                value: action.other_tasks[0].label_id
                            });
                            self.note = action.other_tasks[0].task;
                            break;
                    }
                    if (self.data.occurrence_id) {
                        self.getOccurranceActivity().then(activities => {
                            self.futureActivity = filter(
                                activities.data.response.resources,
                                activity =>
                                    activity.status === 0 &&
                                    activity.isactive &&
                                    activity.occurrence_id ===
                                        self.data.occurrence_id &&
                                    activity.due >= self.data.due
                            );
                            self.previousActivity = _.findLast(
                                filter(
                                    activities.data.response.resources,
                                    activity =>
                                        activity.status === 0 &&
                                        activity.isactive &&
                                        activity.occurrence_id ===
                                            self.data.occurrence_id &&
                                        activity.due < self.data.due
                                )
                            );
                            self.previousActivity = self.previousActivity
                                ? self.previousActivity
                                : {
                                      due: 0
                                  };
                            // Ensure data for repeat activity object as default value for duplicate activity
                            if (self.action == DUPLICATE_ACTIVITY) {
                                self.data.occurence = 1;
                                self.data.specific_interval = 15;
                                self.data.repeat_interval = "minutes";
                                self.data.due_type = 2;
                            } else {
                                self.data.occurence =
                                    self.futureActivity.length;
                            }
                            self.tempOccurCount = self.futureActivity.length;
                        });
                    }
                });
            }
        },
        async templateActivityEdit(params) {
            let self = this;
            await self.getInvoiceBundleTemplateItems();
            if (self.action === "new") {
                self.data.treatment_activity_type_id =
                    this.invoiceBundleItems.length > 0
                        ? TEMPLATES.ACTIVITY_TYPE.MEDICAL
                        : TEMPLATES.ACTIVITY_TYPE.VITALS;
            } else {
                self.timeChange = true;
                self.data.id = params.id;
                self.data.treatment_activity_type_id = params.activity_type;

                if (params.item) {
                    const items = filter(self.invoiceBundleItems, item => {
                        return item.value.item_id == params.item.id;
                    });
                    let item = items[items.length - 1].value;
                    item.quantity = Number(params.activity.quantity);
                    item.item.route = Number(params.activity.route_id);
                    item.item.location = Number(params.activity.location_id);
                    self.data.item = item;
                    self.data.oriItem = item;
                    self.data.uom = params.item.uom;
                } else {
                    if (self.invoiceBundleItems.length > 0) {
                        self.data.item = self.invoiceBundleItems[0].value;
                    }
                }

                if (params.master_vital) {
                    self.data.vital = map(params.master_vital, vital => {
                        return {
                            master_uom_id: vital.master_uom[0].id,
                            label: vital.name,
                            id: vital.id
                        };
                    });
                }

                if (params.activity.due) {
                    self.data.due_type = params.activity.due.type;
                    if (params.activity.due.type == 1) {
                        self.data.due = params.activity.due.after_start_time;
                    } else {
                        // Calculate the seconds since the start of the day
                        self.data.due = DateTime.fromFormat(
                            params.activity.due.specific_time,
                            "hh:mm a",
                            { zone: self._timeZone }
                        );
                    }
                    self.data.specific_time = self.data.due;
                }

                if (params.activity.repeat) {
                    self.data.repeat = params.activity.repeat;
                    self.data.repeat_type = params.activity.repeat.type;
                    self.data.specific_interval =
                        params.activity.repeat.specific_interval;
                    self.data.repeat_interval = "minutes";
                    self.data.occurence = params.activity.repeat.occurence;
                    self.data.occurrence_id = null;
                } else {
                    self.data.repeat_type = 0;
                }

                if (params.activity.label_id) {
                    self.data.note = params.activity.task;
                    self.note = params.activity.task;
                    self.data.label = find(self.labelOptions, {
                        value: params.activity.label_id
                    });
                } else {
                    self.data.label = self.labelOptions[0];
                }

                self.$nextTick(() => {
                    self.timeChange = false;
                });
            }
        },
        shown() {
            this.loading = true;
            $(".modal-content").removeAttr("tabindex");
            Promise.all([
                this.getBundle(),
                this.getRoutes(),
                this.getLocation(),
                this.getPatient()
            ]).then(() => {
                this.loading = false;
            });
        },
        hidden() {
            if (this.$route.path === "/schedule/treatment/activity") {
                this.$router.replace("/schedule/treatment");
            }
        },
        getStaffList() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "staff?getAll=1")
                .then(function (response) {
                    if (response.data.response.resources) {
                        self.staffList = [];
                        response.data.response.resources.forEach(element => {
                            self.staffList.push({
                                id: element.id,
                                fullname: element.fullname
                            });
                        });
                    }
                    return self.staffList;
                });
        },
        getRoleList() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "roles")
                .then(function (response) {
                    if (response.data.response.resources.length > 0) {
                        self.roleList = [];
                        response.data.response.resources.forEach(element => {
                            if (element.staff_count > 0) {
                                self.roleList.push({
                                    id: "R-" + element.id,
                                    fullname:
                                        element.name +
                                        " (" +
                                        element.staff_count +
                                        ")"
                                });
                            }
                        });
                    }
                });
        },
        getInventoryItem(id) {
            return this.$http
                .get(process.env.BARRACUDA + "inventory/" + id)
                .then(response => {
                    return response.data.response.resources;
                });
        },
        getBundle() {
            let self = this;
            return this.$http
                .get(process.env.ACCOUNT_SERVICE + "template/bundle")
                .then(function (response) {
                    self.bundles = response.data.response.resources;
                });
        },
        getActivity(id) {
            return this.$http
                .get(process.env.BARRACUDA + "schedule/activity/" + id)
                .then(response => {
                    return response.data.response.resources;
                });
        },
        getRoutes() {
            let self = this;
            return this.$http
                .get(
                    process.env.BARRACUDA + "reference/master-vaccination-route"
                )
                .then(function (response) {
                    self.routes = response.data.response.resources;
                });
        },
        getLocation() {
            let self = this;
            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "reference/master-vaccination-location"
                )
                .then(function (response) {
                    self.locations = response.data.response.resources;
                });
        },
        getPatient() {
            let updatedLink = this.disablePatientField
                ? `schedule/treatment-board-patient?patient_id=${this.treatmentBoardPatient.id}`
                : "schedule/treatment-board-patient";
            return this.$http
                .get(process.env.BARRACUDA + updatedLink)
                .then(response => {
                    this.pOptions = response.data.response.resources.map(
                        patient => ({
                            id: patient.patient_id,
                            name:
                                patient.patient.name +
                                " " +
                                (patient.actor?.lastname ?? "")
                        })
                    );
                })
                .finally(() => {
                    if (this.getDataFromFetchPatient) {
                        this.data.patient =
                            this.pOptions.find(
                                patient =>
                                    patient.id === this.treatmentBoardPatient.id
                            ) || null;
                    }
                });
        },
        patientChange(patient) {
            let self = this;
            self.data.patient_id = patient ? patient.id : null;
            // self.data.treatment_activity_type_id = null;
            this.patient_id = self.data.patient_id;
        },
        quantityBlur(event) {
            if (event.target.value === "") {
                this.data.quantity = 0;
            }
        },
        isRecurring() {
            let self = this;

            if (
                (self.action === "edit" || self.action === "reactivate") &&
                self.data.occurrence_id
            ) {
                return true;
            }

            return false;
        },
        setDefault() {
            let self = this;
            self.isReset = true;
            self.data.item = [];
            self.data.treatment_activity_type_id = null;
            self.data.uom = null;
            self.data.staffs = null;
            self.data.due_type = self.isTemplate ? 1 : 2;
            self.data.due = DateTime.local().setZone(this._timeZone);
            self.data.repeat = 0;
            self.note = "";
            self.data.quantity = 0;
            self.data.route = 0;
            self.data.location = 0;
            self.data.label = {
                value: 1,
                text: "Miscellaneous"
            };
        },
        setDefaultPartial() {
            let self = this;
            self.isReset = true;
            if (this.type.find(ty => ty.disabled)) {
                self.data.treatment_activity_type_id =
                    TEMPLATES.ACTIVITY_TYPE.VITALS;
                self.data.vital = [];
            } else {
                self.data.treatment_activity_type_id =
                    TEMPLATES.ACTIVITY_TYPE.MEDICAL;
            }
            self.data.item =
                this.invoiceBundleItems.length > 0
                    ? this.invoiceBundleItems[0].value
                    : [];
            self.data.due_type = self.isTemplate ? 1 : 2;
            self.data.due = DateTime.local().setZone(this._timeZone);
            self.data.repeat = 0;
            self.note = "";
        },
        updateSelectedVital(value) {
            if (value) {
                this.clearError("vital");
            }
        },
        clearError(key) {
            this.formError = this.formError.filter(err => err !== key);
        },
        checkFormIsValid() {
            let isValid = !(this.errors.items.length > 0);
            if (
                this.data.treatment_activity_type_id == 2 &&
                this.data.vital.length == 0
            ) {
                this.formError.push("vital");
                isValid = false;
            }
            return isValid;
        },
        async save(continues) {
            let self = this;
            let activityDue = "";
            let response = false;

            if (self.action === "edit" || self.action === DUPLICATE_ACTIVITY) {
                if (self.recreateActivity) {
                    if (self.data.repeat_type === 1) {
                        if (self.data.due_type == 1) {
                            // self.data.due =
                            //     self.previousActivity.due +
                            //     self.convertToMinute(
                            //         self.data.specific_interval,
                            //         self.data.repeat_interval
                            //     );
                        } else {
                            let interval = {};
                            interval[self.data.repeat_interval] = parseInt(
                                self.data.specific_interval
                            );

                            let due = DateTime.isDateTime(self.data.due)
                                ? self.data.due.toSeconds()
                                : self.data.due;
                            self.data.due = DateTime.fromSeconds(due).plus(
                                interval
                            );
                        }
                        activityDue =
                            self.data.due_type === 1
                                ? self.totalDue
                                : self.data.due.toSeconds();
                    } else if (self.data.repeat_type === 2) {
                        self.timeChange = true;
                        let previousDue = DateTime.fromSeconds(
                            self.data?.dueCalculated?.time
                        );
                        let currentDue = self.data.due;

                        if (previousDue && currentDue) {
                            let hours = currentDue.get("hour");
                            let minutes = currentDue.get("minute");
                            let seconds = currentDue.get("second");
                            let milliseconds = currentDue.get("millisecond");

                            let newTime = {
                                hours: hours,
                                minutes: minutes,
                                seconds: seconds,
                                milliseconds: milliseconds
                            };
                            let newDateTime = previousDue.set(newTime);
                            self.data.due = newDateTime;
                        }

                        activityDue = self.data.due.toSeconds();
                        self.data.due_type = 2;
                        self.data.specific_interval = self.previousRepeat
                            ? self.previousRepeat.specific_interval
                            : 0;
                    }
                } else {
                    if (self.data.due_type === 2) {
                        let previousDue = DateTime.fromSeconds(
                            self.data?.dueCalculated?.time
                        );
                        let currentDue = self._toDateTime(self.data.due);

                        /* VET-6837: maintain this code to cater for case changes from previous due
                        specific time to current due specific time if the previous due is different in date */

                        if (previousDue && currentDue) {
                            let year = currentDue.get("year");
                            let month = currentDue.get("month");
                            let day = currentDue.get("day");
                            let hours = currentDue.get("hour");
                            let minutes = currentDue.get("minute");
                            let seconds = currentDue.get("second");
                            let milliseconds = currentDue.get("millisecond");

                            let newTime = {
                                year: year,
                                month: month,
                                day: day,
                                hours: hours,
                                minutes: minutes,
                                seconds: seconds,
                                milliseconds: milliseconds
                            };
                            let newDateTime = previousDue.set(newTime);
                            if (self.action != DUPLICATE_ACTIVITY) {
                                self.data.due = newDateTime;
                            }
                        }
                    }

                    activityDue =
                        self.data.due_type === 1
                            ? self.totalDue
                            : self._toDateTime(self.data.due).toSeconds();
                }
            } else {
                activityDue =
                    self.data.due_type === 1
                        ? self.totalDue
                        : self._toDateTime(self.data.due).toSeconds();
            }

            let valid = await self.$validator.validateAll();
            if (!self.checkFormIsValid()) {
                return false;
            }

            if (valid) {
                let data = {
                    treatment_board_id: self.data.treatment_board_id,
                    patient_id: self.data.patient.id,
                    treatment_activity_type_id:
                        self.data.treatment_activity_type_id,
                    due: activityDue,
                    due_type: self.data.due_type,
                    action: self.action,
                    status:
                        self.action === "reactivate" ||
                        self.action === DUPLICATE_ACTIVITY
                            ? 0
                            : self.data.status
                };
                this.loading = true;

                switch (self.data.treatment_activity_type_id) {
                    case 1: {
                        let medicationArray = [];
                        if (self.data.item) {
                            $.each(self.data.item, function (key, value) {
                                let array = {
                                    treatment_medication_id: value.treatment_medication_id
                                        ? value.treatment_medication_id
                                        : self.treatment_medication_id,
                                    item_id: value.id,
                                    quantity: self.data.quantity,
                                    location_id: self.data.location,
                                    route_id: self.data.route,
                                    status: 0
                                };
                                medicationArray.push(array);
                            });
                        }

                        data = {
                            ...data,
                            note: self.note,
                            medications: medicationArray
                        };
                        break;
                    }
                    case 2: {
                        let vitalArray = [];
                        if (self.data.vital) {
                            $.each(self.data.vital, function (key, value) {
                                let array = {
                                    vital_id: "",
                                    master_vital_id: value.id,
                                    value: "",
                                    master_uom_id: value.master_uom_id,
                                    note: "",
                                    status: 0
                                };
                                vitalArray.push(array);
                            });
                        }

                        data = {
                            ...data,
                            note: self.note,
                            vitals: vitalArray
                        };
                        break;
                    }
                    case 3: {
                        let staffs = [];
                        if (self.data.staffs && self.data.staffs.length > 0) {
                            $.each(self.data.staffs, function (key, value) {
                                staffs.push(value.id);
                            });
                        }
                        data = {
                            ...data,
                            note: self.note,
                            otherTasks: [
                                {
                                    treatment_other_task_id:
                                        this.action !== "new"
                                            ? self.data.other_tasks[0]
                                                ? self.data.other_tasks[0].id
                                                : ""
                                            : "",
                                    label_id: self.data.label.value,
                                    task: self.note,
                                    staff_id: staffs,
                                    contact_id: self.data.contact_id
                                        ? [self.data.contact_id.id]
                                        : [],
                                    status: 0
                                }
                            ]
                        };
                    }
                }

                // --- set repeat times
                if (self.data.occurence > 1) {
                    if (self.action === "new") {
                        data["repeat_data"] = {
                            occurence: self.data.occurence,
                            specific_interval: self.convertToMinute(
                                self.data.specific_interval,
                                self.data.repeat_interval
                            ),
                            specific_time: null,
                            type: 1
                        };
                    } else if (self.action === "edit") {
                        data["repeat_data"] = self.previousRepeat;
                    }
                    data["repeat"] = JSON.stringify(data["repeat_data"]);
                    data["repeat_type"] = self.data.due_type;
                    data["repeat_time"] = times(
                        parseInt(self.data.occurence) - 1,
                        i => {
                            let interval = {};
                            if (self.data.due_type != 1) {
                                interval[self.data.repeat_interval] =
                                    self.data.repeat_type == 1
                                        ? parseInt(
                                              self.data.specific_interval
                                          ) *
                                          (i + 1)
                                        : 0;
                            }

                            return self.data.due_type === 1
                                ? parseInt(
                                      self.convertToMinute(
                                          self.data.specific_interval,
                                          self.data.repeat_interval
                                      )
                                  ) *
                                      (i + 1) +
                                      self.totalDue
                                : self
                                      ._toDateTime(self.data.due)
                                      .plus(interval)
                                      .toSeconds();
                        }
                    );
                }

                if (self.recreateActivity && self.action === "edit") {
                    // delete activity
                    response = await self.$http.delete(
                        process.env.BARRAMUNDI +
                            "/schedule/group-activities/" +
                            self.data.occurrence_id,
                        {
                            params: {
                                activities: self.futureActivity.map(id => id.id)
                            }
                        }
                    );
                    // recreate activity with same occurance id
                    data["occurrence_id"] = self.data.occurrence_id;

                    response = await self.createActivity(data);
                }

                if (
                    self.data.occurrence_id &&
                    self.data.apply_to === 1 &&
                    !self.recreateActivity
                ) {
                    response = await self.saveOccurrance(data);
                } else if (
                    self.action === "new" ||
                    self.action === DUPLICATE_ACTIVITY
                ) {
                    response = await self.createActivity(data);
                } else {
                    response = await self.$http.put(
                        process.env.BARRAMUNDI +
                            "schedule/activity/" +
                            self.data.id,
                        data
                    );
                }

                if (response.status === 200) {
                    self._message("Activity saved", "success");
                    self.$root.$emit("treatment-board-refresh", {
                        params: response.data.response,
                        treatment_board_id:
                            response.data.response.resources.treatment_board_id
                    });
                    if (continues) {
                        self.$validator.reset();
                        self.continues = true;
                        self.loading = false;
                        this.setDefault();
                    } else {
                        self.$refs.treatementActivity.hide();
                    }
                } else {
                    self.loading = false;
                    self._message("Activity save error", "danger");
                }
            }
        },
        async saveTemplate(continues) {
            let self = this;

            let afterStartTime = null;
            let specificTime = null;
            if (self.data.due_type == 1) {
                afterStartTime = self.totalDue;
            } else {
                specificTime = self.data.due.toFormat("hh:mm a");
            }

            let data = {
                template_id: self.templateId,
                activity_type: self.data.treatment_activity_type_id,
                activity: {
                    due: {
                        type: self.data.due_type,
                        after_start_time: afterStartTime,
                        specific_time: specificTime
                    }
                }
            };

            if (self.data.repeat_type == 1) {
                if (Number(self.data.occurence) > 1) {
                    data.activity.repeat = {
                        type: self.data.repeat_type,
                        specific_interval: self.convertToMinute(
                            self.data.specific_interval,
                            self.data.repeat_interval
                        ),
                        specific_time: specificTime,
                        occurence: Number(self.data.occurence)
                    };
                }
            }

            let valid = await self.$validator.validateAll();
            if (!self.checkFormIsValid()) {
                return false;
            }
            if (valid) {
                this.loading = true;
                switch (self.data.treatment_activity_type_id) {
                    case 1: {
                        data.activity = {
                            ...data.activity,
                            item_id: self.data.item.item_id,
                            quantity: Number(self.data.quantity),
                            route_id: self.data.route,
                            location_id: self.data.location
                        };
                        break;
                    }
                    case 2: {
                        data.activity = {
                            ...data.activity,
                            master_vital_id: map(
                                self.data.vital,
                                vital => vital.id
                            )
                        };
                        break;
                    }
                    case 3: {
                        data.activity = {
                            ...data.activity,
                            label_id: self.data.label?.value,
                            task: self.note
                        };
                        break;
                    }
                }
                try {
                    let res;
                    if (this.action == "edit") {
                        res = await TEMPLATE_SERVICES.updateActivity(
                            this.data.id,
                            data
                        );
                    } else {
                        res = await TEMPLATE_SERVICES.saveActivity(data);
                    }

                    if (res.message?.code == 200) {
                        this._message("Activity successfully saved");
                        this.$emit("refresh");
                        if (continues) {
                            self.$validator.reset();
                            self.continues = true;
                            this.setDefaultPartial();
                        } else {
                            self.$refs.treatementActivity.hide();
                        }
                    } else {
                        throw new Error("Error: Unable to save activity");
                    }
                } catch (error) {
                    this._message(error.message, "danger");
                } finally {
                    this.loading = false;
                }
            }
        },
        convertToMinute(interval, from_interval) {
            let inMinute = "";
            switch (from_interval) {
                case "minutes":
                    inMinute = interval;
                    break;
                case "hours":
                    inMinute = interval * 60;
                    break;
                case "days":
                    inMinute = interval * 24 * 60;
                    break;
                case "weeks":
                    inMinute = interval * 7 * 24 * 60;
                    break;
                case "months":
                    inMinute = interval * 30 * 24 * 60;
                    break;
            }
            return inMinute;
        },
        async getOccurranceActivity() {
            let self = this;
            return await self.$http.get(
                process.env.BARRACUDA +
                    "schedule/group-activities/" +
                    self.data.occurrence_id
            );
        },
        async createActivity(data) {
            let self = this;
            return await self.$http.post(
                process.env.BARRAMUNDI + "schedule/activity",
                data
            );
        },
        async saveOccurrance(object) {
            let self = this;
            const activities = await self.getOccurranceActivity();

            let params = filter(
                activities.data.response.resources,
                activity =>
                    activity.isactive &&
                    activity.occurrence_id === self.data.occurrence_id &&
                    activity.due >= self.data.due
            ).map(activity => ({
                ...object,
                due: activity.due,
                treatment_activity_id: activity.id
            }));
            return await self.$http.put(
                process.env.BARRACUDA + "schedule/activities",
                params
            );
        },
        async getInvoiceBundleTemplateItems() {
            try {
                this.loading = true;

                const res = await TEMPLATE_SERVICES.getItems(this.templateId);
                if (res.code == 200) {
                    this.invoiceBundleItems = chain(res.resources)
                        .filter(item => item.item?.status != 0 && item.item)
                        .map(item => {
                            item.uom = this.uoms[item?.item.uom];
                            return {
                                value: item,
                                text: item.item?.name || item.item?.display_name
                            };
                        })
                        .value();
                    if (this.action == "new") {
                        if (this.invoiceBundleItems.length > 0) {
                            this.data.item = this.invoiceBundleItems[0].value;
                        } else {
                            let medicalType = map(this.type, type => {
                                if (type.value == 1) {
                                    type.disabled = true;
                                }
                                return type;
                            });
                            this.type = medicalType;
                        }
                    }
                } else {
                    throw new Error("Error: Unable to fetch items");
                }
            } catch (error) {
                this._message(error.message, "danger");
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
<style>
/* Hide the expand/collapse arrow for "Select All" container */
.treeselect-select-all
    .vue-treeselect__option[data-id="all"]
    .vue-treeselect__option-arrow-container {
    display: none;
}
/* Hide expand/collapse arrow */
.treeselect-select-all
    .vue-treeselect__option[data-id="select-all"]
    .vue-treeselect__label-container
    .vue-treeselect__option-arrow {
    display: none;
}
.treeselect-select-all:has(.vue-treeselect__option--matched[data-id="all"])
    .vue-treeselect__label-container
    .vue-treeselect__option-arrow {
    display: none;
}

/* Ensure the children are visually aligned without extra margin/padding */
.treeselect-select-all:has(.vue-treeselect__option--matched[data-id="all"])
    .vue-treeselect__option[data-id="all"] {
    padding-left: 5px;
}
.treeselect-select-all .vue-treeselect__option[data-id="all"] {
    padding-left: 20px;
}
.treeselect-select-all
    .vue-treeselect__list
    .vue-treeselect__list-item
    .vue-treeselect__indent-level-1
    .vue-treeselect__option {
    padding-left: 0px;
}
</style>
